import { Component, OnInit, OnDestroy } from "@angular/core";
import { NavigationService } from "../../../providers/navigation.service";
import { ActivatedRoute, Router } from "@angular/router";
import { ApiService } from "../../../providers/api.service";
import { Subscription } from "rxjs";
import { SM_CONSTANTS } from "../../../shared/constants/sm-constants";
import { ITableColumnHeader } from "../../../models/table-column-header";
import { AddServiceComponent } from "src/app/shared/components/add-service/add-service.component";
import { MatDialog } from "@angular/material/dialog";
import { SharedService } from "../../../providers/shared.service";
import { UntypedFormControl } from "@angular/forms";
import { AddServiceTemplateItemComponent } from "src/app/shared/components/add-service-template-item/add-service-template-item.component";
import { AddServiceTimingsComponent } from "src/app/shared/components/add-service-timings/add-service-timings.component";
import { LoaderServiceService } from "src/app/providers/loader-service.service";
import { MessagingService } from "src/app/providers/messaging.service";
import { AngularFireMessaging } from "@angular/fire/compat/messaging";
import { TranslateService } from "@ngx-translate/core";
import { FollowerChatComponent } from "src/app/shared/components/follower-chat/follower-chat.component";
import { FollowerReportAbuseComponent } from "src/app/shared/components/follower-report-abuse/follower-report-abuse.component";
import { YoutubeEmbedVideoComponent } from "../../new-v2-pages/new-v2-component/youtube-embed-video/youtube-embed-video.component";
import { DialogService } from "src/app/providers/dialog.service";

@Component({
  selector: "sm-folowers",
  templateUrl: "./folowers.component.html",
  styleUrls: ["./folowers.component.scss"],
})
export class FolowersComponent implements OnInit, OnDestroy {
  entityHashId: string = "";
  serviceType: string = "";
  public loader: boolean = false;
  serviceTimings: any = [];
  finalServiceTimings: any = [];
  serviceList: any[] = [];
  private _apiSubscription: Subscription;
  datalength!: number;
  public page: number = 1;
  searchString: UntypedFormControl = new UntypedFormControl("");
  followersData: any = [];
  daysOfWeek = [
    { day: 1, name: "Sunday" },
    { day: 2, name: "Monday" },
    { day: 3, name: "Tuesday" },
    { day: 4, name: "Wednesday" },
    { day: 5, name: "Thursday" },
    { day: 6, name: "Friday" },
    { day: 7, name: "Saturday" },
  ];

  tableDisplayColumns: ITableColumnHeader[] = [
    {
      columnName: this.translateService.instant(
        "followers.column_headers.name"
      ),
      columnProperty: "name",
    },
    {
      columnName: this.translateService.instant(
        "followers.column_headers.address"
      ),
      columnProperty: "addressLine",
    },
  ];
  isfromhere: boolean = false;
  previousChatHash: any = null;
  senderHashId: any = localStorage.getItem(SM_CONSTANTS.PROFILE_HASH);
  receiverHashId: any;
  constructor(
    private _navService: NavigationService,
    private dialog: MatDialog,
    private route: ActivatedRoute,
    private _apiService: ApiService,
    private _modelRef: MatDialog,
    private sharedService: SharedService,
    private loaderservice: LoaderServiceService,
    private messagingService: MessagingService,
    private angularFireMessaging: AngularFireMessaging,
    private translateService: TranslateService,
    private router: Router,
    private dialogservice: DialogService
  ) {
    this._navService.hideSidebarAndNav = false;
    // this.clickEventSubscription = this.sharedService.getClickEvent().subscribe(() => {
    //   this.ngOnInit();
    // })

    this._apiSubscription = this._apiService.apiResult.subscribe((resData) => {
      if (
        resData.responseType ===
        SM_CONSTANTS.RESULT_API_GET_ENTITY_FAVOURITES_LIST
      ) {
        this.followersData = [];
        if (resData.result) {
          resData.result = resData.result.filter((item:any) => item.profieleDetails != null && item.profieleDetails)
          this.followersData = this.cleanAndFlatten(resData.result);
          console.log(this.followersData);
        }
        this.loaderservice.showLoader = false;
        this.loader = false;
      } else if (
        resData.responseType ===
        SM_CONSTANTS.RESULT_API_UPDATE_ENTITY_HOME_SERVICE_TIMINGS
      ) {
        if (resData.result) {
          this.ngOnInit();
        }
      } else if (
        resData.responseType ===
        SM_CONSTANTS.RESULT_API_UPDATE_ENTITY_SHOP_SERVICE_TIMINGS
      ) {
        if (resData.result) {
          this.ngOnInit();
        }
      } else if (
        resData.responseType === SM_CONSTANTS.RESULT_API_GET_MESSAGES_BY_ID
      ) {
        if (this.isfromhere) {
          this.isfromhere = false;
          this.previousChatHash = null;
          // this.chatThreads = []
          if (resData.result) {
            resData.result.forEach((element: any) => {
              if (element.senderInfo && element.receiverInfo) {
                if (
                  element.senderInfo &&
                  typeof element.senderInfo == "string"
                ) {
                  element.senderInfo = JSON.parse(element.senderInfo);
                }
                if (
                  element.receiverInfo &&
                  typeof element.receiverInfo == "string"
                ) {
                  element.receiverInfo = JSON.parse(element.receiverInfo);
                }
                if (
                  (element.senderInfo.hash_id == this.senderHashId &&
                    element.receiverInfo.hash_id == this.receiverHashId &&
                    element.entity_public_hash_id ==
                      localStorage.getItem(
                        SM_CONSTANTS.CURRENT_ENTITY_PUBLIC_PROFILE_HASH_ID
                      )) ||
                  (element.senderInfo.hash_id == this.receiverHashId &&
                    element.receiverInfo.hash_id == this.senderHashId &&
                    element.entity_public_hash_id ==
                      localStorage.getItem(
                        SM_CONSTANTS.CURRENT_ENTITY_PUBLIC_PROFILE_HASH_ID
                      ))
                ) {
                  this.previousChatHash = element.hash_id;
                }
              }
            });
            console.log(this.previousChatHash);
          }
          this.loaderservice.showLoader = false;
          let data = {
            title: this.selectedFollowerName,
            ref: this._modelRef,
            previousChatHash: this.previousChatHash,
            followerImage: this.selectedFollowerImg,
            folowerProfileHash: this.selectedFollowerProfileHash, //
          };
          this.dialogservice.openFullScreenDialog(FollowerChatComponent,data);
        }
      }
    });
    console.log(this.serviceList);
    if (
      !localStorage.getItem(SM_CONSTANTS.KEY_FCM_TOKEN) ||
      localStorage.getItem(SM_CONSTANTS.KEY_FCM_TOKEN) == null ||
      localStorage.getItem(SM_CONSTANTS.KEY_FCM_TOKEN) == "null"
    ) {
      this.messagingService.requestPermission();
    }
    this.translateService.onLangChange.subscribe(() => {
      // Update your column headers when the language changes
      this.updateColumnHeaders();
    });
  }
  private updateColumnHeaders() {
    this.tableDisplayColumns.forEach((column, index) => {
      let data = ["name", "address"];

      // Update each column header with the translated value
      column.columnName = this.translateService.instant(
        `followers.column_headers.${data[index]}`
      );
    });
  }
  // private modelSubscription: Subscription = new Subscription();
  ngOnInit(): void {
    this.loader = true;
    this.loaderservice.showLoader = true;
    this.route.queryParams.subscribe((data) => {
      console.log(data.entityHash);
      this.entityHashId = data.entityHash;
      this._apiService.getEntityFavouritesList(this.entityHashId);
    });
  }

  reportAbuse(rowvalue: any) {
    // this.loaderservice.showLoader = false
    this._modelRef.open(FollowerReportAbuseComponent, {
      width: "660px",
      data: {
        ref: this._modelRef,
        name: rowvalue.name,
        followerHash: rowvalue.hash_id,
      },
    });
  }
  createNotification(title: any, text: any) {
    const noti = new Notification(title, {
      body: text,
    });
  }

  openPublicPost(rowvalue: any) {
    this.router.navigate(["public-posts"], {
      relativeTo: this.route,
      queryParams: { accountHash: rowvalue.hash_id },
      queryParamsHandling: "merge",
    });
  }
  openPublicMedia(rowvalue: any) {
    this.router.navigate(["public-media"], {
      relativeTo: this.route,
      queryParams: { accountHash: rowvalue.hash_id },
      queryParamsHandling: "merge",
    });
  }

  selectedFollowerName: any;
  selectedFollowerImg: any;
  selectedFollowerProfileHash: any;
  openMessages(rowvalue: any) {
    this.isfromhere = true;
    this.selectedFollowerName = rowvalue.name;
    this.selectedFollowerImg = rowvalue.profile_thumb;
    this.selectedFollowerProfileHash = rowvalue.profule_hash;
    this.receiverHashId = rowvalue.profule_hash;
    this.loaderservice.showLoader = true;
    this._apiService.getMessagesByID();
  }

  ngOnDestroy(): void {
    this._apiSubscription.unsubscribe();
    // this.clickEventSubscription.unsubscribe();
    // this.modelSubscription.unsubscribe();
  }

  convertTo12HourFormat(timeString: any) {
    const [hours, minutes] = timeString.split(":");
    let period = "AM";
    let hour = parseInt(hours, 10);

    if (hour >= 12) {
      period = "PM";
      if (hour > 12) {
        hour -= 12;
      }
    }

    return `${hour.toString().padStart(2, "0")}:${minutes} ${period}`;
  }

  openvideo() {
    this.dialog.open(YoutubeEmbedVideoComponent, {
      width: "1000px",
      disableClose: true,
      data: {
        link: "",
        title: "Business profile",
      },
    });
  }

  opencontact() {
    this.router.navigate(["/contact-us"]);
  }
  openLink(url: string): void {
    window.open(url, "_blank");
  }

  cleanAndFlatten(data: any[]): any[] {
    return data.map((item) => {
      let parsed: { [key: string]: any } = {};

      try {
        parsed = JSON.parse(item.profieleDetails);
      } catch (e) {
        console.warn("Invalid JSON in profieleDetails:", item.profieleDetails);
      }

      // Convert "null" strings to actual null
      for (const key in parsed) {
        if (parsed[key] === "null") {
          parsed[key] = null;
        }
      }

      // ✅ Format dob and assign to dob1
      let dob1 = "---";
      if (parsed.dob) {
        try {
          const dateObj = new Date(parsed.dob);
          const options: Intl.DateTimeFormatOptions = {
            day: "numeric",
            month: "long",
          };
          dob1 = isNaN(dateObj.getTime())
            ? "---"
            : dateObj.toLocaleDateString("en-GB", options);
        } catch {
          dob1 = "---";
        }
      }

      // ✅ Clean address
      if (parsed.address) {
        const parts = parsed.address.split(",").map((p: any) => p.trim());
        const filtered = parts.filter(
          (p: any) => p && p.toLowerCase() !== "null"
        );
        parsed.address = filtered.length > 0 ? filtered.join(", ") : "---";
      }

      // ✅ Replace null/empty fields (except profile_thumb)
      for (const key in parsed) {
        if (
          key !== "profile_thumb" &&
          key !== "dob" && // skip dob since it's moved to dob1
          (parsed[key] === null ||
            parsed[key] === undefined ||
            parsed[key] === "" ||
            parsed[key]?.toString().toLowerCase() === "null")
        ) {
          parsed[key] = "---";
        }
      }

      // ✅ Format favourited_on_date
      let formattedDate = "---";
      if (item.favourited_on_date) {
        const date = new Date(item.favourited_on_date);
        if (!isNaN(date.getTime())) {
          formattedDate = date.toLocaleDateString("en-US", {
            month: "long",
            day: "numeric",
            year: "numeric",
          });
        }
      }

      return {
        ...item,
        ...parsed,
        dob1, // 👈 set the final dob1
        favourited_on_date: formattedDate,
        profieleDetails: undefined,
      };
    });
  }
}
